<template>
  <div class="to-do-card-edit">
    <i
      v-if="$_isDisplay('checkIcon')"
      :class="{
        'icon-check-circle-filled leading-icon complete': complete,
        'icon-check-circle-outline leading-icon': !complete,
      }"
    />
    <IconButton
      v-if="$_isDisplay('deleteIcon')"
      color="red"
      tooltipText="刪除"
      icon="icon-delete"
      class="delete"
      @click="$_deleteCard()"
    />
    <div class="card-container">
      <div class="card-item pr-22">
        <InputTextareaButton
          v-model="C_value.name"
          bold
          noErrorText
          rules="required"
          placeholder="待辦事項主旨"
          :minHeight="50"
          :maxHeight="50"
          @input="$_dataChange()"
        />
      </div>
      <div class="card-item content-item pr-22">
        <InputTextareaButton
          v-model="C_value.remark"
          noErrorText
          placeholder="待辦事項說明"
          :rules="requiredFieldObject.remark ? 'required' : ''"
          @input="$_dataChange()"
        />
      </div>
      <WsRow
        v-if="$_isDisplay('taker') || $_isDisplay('date') || $_isDisplay('multiSystemClasses')"
        class="mt-2 pr-22"
      >
        <WsCol v-if="$_isDisplay('taker')" cols="4" smcols="12">
          <DropdownSelectMenuButton
            v-model="C_value.taker"
            outline
            noErrorText
            hasCancelIcon
            placeholder="選擇人員"
            leadingIcon="icon-outline-perm-identity"
            :scroll="scroll"
            :selectValue="C_value.takerValue"
            :rules="requiredFieldObject.taker ? 'required' : ''"
            @input="$_dataChange()"
            @input-item="$_dataChange($event, 'takerValue')"
          />
        </WsCol>
        <WsCol v-if="$_isDisplay('date')" cols="4" smcols="12">
          <StateDatePickerInput
            v-model="C_value.expired_at"
            noErrorText
            notBeforeDisabledDate
            rules="required"
            leadingIcon="icon-duedate"
            placeholder="設定期限"
            :scroll="scroll"
            :disabledDate="$dayjs().toDate()"
            @input="$_dataChange()"
          />
        </WsCol>
        <WsCol v-if="$_isDisplay('multiSystemClasses')" cols="4" smcols="12">
          <LvDropdownMultiSystemClasses
            v-model="C_value.multiSystemClasses"
            title=""
            placeholder="選擇領域"
            noErrorText
            hasCancelIcon
            :rules="requiredFieldObject.multiSystemClasses ? 'required' : ''"
            :selectValue="C_value.multiSystemClassesSelectValue"
            :propsMenuItems="propsMenuItems"
            @init-value="$_onInitMultiSystemClasses"
            @input="$_onMultiSystemClassesInput"
          />
        </WsCol>
      </WsRow>
      <LvUploadFileBtn
        type="text"
        :uploadModule="uploadModule"
        :selectedFileList="C_value.attaches"
        :remindText="`${$t('檔案大小限制')} ≤ 30 MB`"
        class="mt-12"
        @input="$_dataChange($event, 'attaches')"
      />
      <div v-if="C_value.errors && C_value.errors.length > 0" class="invalid-text">
        <i class="icon-warning invalid-icon" />
        <p v-for="(text_e, text_k) in C_value.errors" :key="text_k" class="text">
          {{ $t(text_e) }}
        </p>
      </div>
      <div v-if="C_value.attaches && C_value.attaches.length > 0" class="file-list">
        <LvDownloadFileBtn
          v-for="(attach_e, attach_k) in C_value.attaches"
          download
          showDeleteBtn
          :key="attach_k"
          :num="attach_k"
          :id="attach_e.id"
          :url="attach_e.url"
          :name="attach_e.name"
          :module="uploadModule"
          :fileType="attach_e.fileType"
          :hasScope="attach_e.hasScope"
          :isSystem="attach_e.isSystem"
          :chipList="attach_e.chipList"
          :isLoading="attach_e.isLoading"
          :versionNumber="attach_e.versionNumber"
          :showDownloadBtn="attach_e.showDownloadBtn"
          :isClickable="attach_e.isClickable"
          :isImageViewable="_isImageViewable"
          class="file"
          @go-to="$emit('go-to', attach_e.id)"
          @remove="$_deleteFileClick(attach_k)"
        />
      </div>
      <LvStateTaskLinks
        bgWhite
        labelSm
        :labelMd="false"
        :list="links"
        class="mt-10"
        @add="$emit('add-related-module')"
        @delete="$emit('delete-related-module', $event)"
        @input="$emit('input-related-module', $event)"
        @paste="$emit('paste-related-module', $event)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ToDoCardEdit',
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    scroll: {
      type: Number,
      default: 0,
    },
    uploadModule: {
      type: String,
    },
    hideFields: {
      type: Array,
    },
    links: {
      type: Array,
      default: () => [],
    },
    requiredFieldObject: {
      type: Object,
      default: () => ({
        taker: true,
        multiSystemClasses: true,
        remark: true,
      }),
    },
    propsMenuItems: {
      type: Array,
    },
  },
  data: () => ({
    complete: false,
    check: true,
    fileShow: true,
    C_value: {
      done_at: null,
      start_at: '',
      expired_at: '',
      name: '',
      remark: '',
      taker: null,
      takerValue: {},
      attaches: [],
      errors: [],
      multiSystemClasses: [],
    },
  }),
  computed: {
    _displayFieldsMap() {
      if (!Array.isArray(this.hideFields)) return null;
      return new Set(this.hideFields.filter(item => typeof item === 'string'));
    },
    _isImageViewable() {
      return this.$store.state.app.factory.isImageViewable;
    },
  },
  watch: {
    value() {
      this.$_syncCValue();
    },
  },
  mounted() {
    this.$_syncCValue();
    this.$_setCompleteStatus(this.C_value);
  },
  methods: {
    $_syncCValue() {
      this.C_value = {
        multiSystemClasses: [],
        ...this.value,
      };
    },
    $_dataChange($event, type) {
      if (!type) {
        this.$emit('input', this.C_value);
        return;
      }
      const currentVal = this.C_value[type];
      this.C_value[type] = Array.isArray(currentVal)
        ? [...currentVal, ...$event]
        : currentVal && typeof currentVal === 'object'
        ? { ...currentVal, ...$event }
        : $event;
      this.$emit('input', this.C_value);
    },
    $_deleteCard() {
      this.$emit('delete');
    },
    $_subTaskHasDate(date) {
      if (date) return true;
      return false;
    },
    $_setCompleteStatus(task) {
      this.complete = !!task.done_at;
    },
    $_deleteFileClick(attacheIndex) {
      this.C_value.attaches.splice(attacheIndex, 1);
      this.$_dataChange();
    },
    $_isDisplay(field) {
      if (!this._displayFieldsMap) return true;
      return !this._displayFieldsMap.has(field);
    },
    $_onInitMultiSystemClasses(value) {
      this.C_value.multiSystemClasses = value;
      this.$_dataChange();
    },
    $_onMultiSystemClassesInput(value) {
      this.C_value.multiSystemClasses = value;
      if (!value?.length) {
        this.C_value.multiSystemClassesSelectValue = {
          system_classes: [],
          system_subclasses: [],
          factory_system_classes: [],
          factory_system_subclasses: [],
        };
      }
      this.$_dataChange();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/to-do-card-edit';
</style>
